"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var CustomCursor = function CustomCursor(_ref) {
  var startPosition = _ref.startPosition,
    customIcon = _ref.customIcon;
  var cursorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentPosition = _useState2[0],
    setCurrentPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    lastScrollY = _useState4[0],
    setLastScrollY = _useState4[1];
  var updatePosition = (0, _react.useCallback)(function (_ref2) {
    var x = _ref2.x,
      y = _ref2.y;
    var cursor = cursorRef.current;
    setCurrentPosition({
      x: x,
      y: y
    });
    if (cursor) {
      cursor.style.left = "".concat(x, "px");
      cursor.style.top = "".concat(y, "px");
    }
  }, []);
  var handleMouseMove = (0, _react.useCallback)(function (_ref3) {
    var clientX = _ref3.clientX,
      clientY = _ref3.clientY;
    var cursor = cursorRef.current;
    if (cursor !== null && cursor !== void 0 && cursor.offsetParent) {
      var _cursor$offsetParent$ = cursor.offsetParent.getBoundingClientRect(),
        top = _cursor$offsetParent$.top,
        left = _cursor$offsetParent$.left;
      updatePosition({
        x: clientX - left,
        y: clientY - top
      });
    }
  }, [updatePosition]);
  var handleScroll = (0, _react.useCallback)(function () {
    var scrolledY = window.scrollY - lastScrollY;
    updatePosition(_objectSpread(_objectSpread({}, currentPosition), {}, {
      y: (currentPosition === null || currentPosition === void 0 ? void 0 : currentPosition.y) + scrolledY
    }));
    setLastScrollY(window.scrollY);
  }, [lastScrollY, currentPosition, updatePosition]);
  (0, _react.useEffect)(function () {
    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);
  (0, _react.useEffect)(function () {
    var _cursorRef$current;
    setLastScrollY(window.scrollY);
    var parent = (_cursorRef$current = cursorRef.current) === null || _cursorRef$current === void 0 ? void 0 : _cursorRef$current.offsetParent;
    parent === null || parent === void 0 ? void 0 : parent.addEventListener("mousemove", handleMouseMove);
    handleMouseMove(_objectSpread({}, startPosition));
    return function () {
      parent === null || parent === void 0 ? void 0 : parent.removeEventListener("mousemove", handleMouseMove);
    };
  }, [startPosition, handleMouseMove]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "custom-cursor",
    ref: cursorRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, customIcon));
};
var _default = CustomCursor;
exports.default = _default;